module.exports = __webpack_public_path__ + "static/media/HardwareDeleteIcon.c331cc24.svg";